export default __webpack_public_path__ + "static/media/bolt-gradient.f50e8274.svg";